import { useState } from "react";

const ModalPopupOne = ({
  showPopUpAction,
  setShowPopUpAction,
  feedback,
  onComplete,
  t,
  currentStep,
  setCurrentStep,
  lastQuestion,
  language,
}) => {
  function handleClose() {
    setShowPopUpAction(false);
    setCurrentStep(currentStep + 1);
  }

  const [showQ4Extra, setShowQ4Extra] = useState(false)
  const actLanguage = language === "malay" ? 'bm' : 'en'

  const q4Feedback = {en: [
        
        "Mental health affects many aspects of daily life",
        "Untreated mental health issues can worsen diabetes. By the same token challenges faced with diabetes can also make mental health issues worse.",
        "Talk to you healthcare team if you’re concerned about your mental health. You’re not alone - help is available."
      ],
      bm: [
        "Kesihatan mental mempengaruhi banyak aspek kehidupan seharian.",
        "Isu kesihatan mental yang tidak dirawat boleh memburukkan lagi diabetes. Dengan cara yang sama, cabaran yang dihadapi dengan diabetes juga boleh memburukkan masalah kesihatan mental.",
        "Bercakap dengan pasukan penjagaan kesihatan anda jika anda bimbang tentang kesihatan mental anda. Anda tidak bersendirian - bantuan tersedia."
        ]}
  return (
    <div className="mt-3">
      <center>
        <img
          src={`https://mystatic123.s3.ap-southeast-1.amazonaws.com/modules/module1/1.${
            currentStep + 1 === 4 ? showQ4Extra ? 5 : 4 : currentStep + 1
          }.jpeg`}
          style={{
            width: '100%',
            height: '15rem',
            objectFit: 'contain',
          }}
          alt="success"
        />
      </center>
      <div className="mt-3 fw-bold mx-4">
        {lastQuestion ? (
          <div>
            <div className="ms-4">
              {feedback.feedback && feedback.feedback[0]}
            </div>
            {feedback.feedback &&
              feedback.feedback.map((each, idx) => {
                if (idx > 0) {
                  return (
                    <ul
                      className="ms-3"
                      key={idx}
                      style={{ paddingRight: '5px' }}
                    >
                      <li>{each} </li>
                    </ul>
                  );
                }
              })}
          </div>
        ) : currentStep + 1 === 4 ? showQ4Extra ?  (
          q4Feedback?.[actLanguage].map((each, idx) => {
            return (
              <ul key={idx} style={{ paddingRight: '5px' }}>
                <li>{each} </li>
              </ul>
            );
          })) : (
          <div>
            <h2 className="fw-bold brandon-grotesque-regular override-font mb-3">{feedback.feedback[0]}</h2>
          {feedback.feedback &&
          feedback.feedback.filter((_, index) => index !== 0).map((each, idx) => {
            return (
              <ul key={idx} style={{ paddingRight: '5px' }}>
                <li>{each} </li>
              </ul>
            );
          })}
          </div>
        ) : (
          feedback.feedback &&
          feedback.feedback.map((each, idx) => {
            return (
              <ul key={idx} style={{ paddingRight: '5px' }}>
                <li>{each} </li>
              </ul>
            );
          })
        )}

        <div className="mx-3 mb-3">
          <button
            className="custom-primary-button mt-2"
            onClick={lastQuestion ? () => onComplete() : currentStep + 1 === 4 ? showQ4Extra ? () => handleClose() : () => setShowQ4Extra(true) : () => handleClose() }
          >
            {t('ContinueM')}
          </button>
        </div>
      </div>{' '}
    </div>
  );
};

export default ModalPopupOne;
